import { useReducer } from "react";
import PouchDB from "pouchdb";
var deepEqual = require("deep-equal");

PouchDB.plugin(require("pouchdb-upsert"));
PouchDB.plugin(require("crypto-pouch"));

// Note: React calls the reducer twice, so the console log repeats
// https://github.com/facebook/react/issues/16295#issuecomment-610098654

export const prepDoc = (collection, table, rowid, doc) => {
  var pouchCollate = require("pouchdb-collate");
  doc._id = pouchCollate
    .toIndexableString([collection, table, rowid])
    .replace(/\u0000/g, "\u0001");
  return doc;
};

const pluck = new Audio("/icons/pluck.mp3");
const pluckTypes = ["w.topic.message", "w.mpersona.message"];

// In Dev mode, React will execute the reduce function twice, to highlight any side effects
// In our case, we are deliberately using the side effect to populate the database
// so when upserting a document, we break out when the existing  doc is identical to the new doc
const compareDocs = (a, b) => {
  let c = { ...a, _rev: "", _deleted: a.undeleted };
  let d = { ...b, _rev: "", _deleted: b.undeleted };
  console.log("existingDoc", c);
  console.log("newDoc", d);
  return deepEqual(c, d);
};

const reducer = (state, action) => {
  let db;
  let doc;
  switch (action.type) {
    case "DELETE_STREAM_MESSAGES":
      db = action.values.db;
      db.allDocs({
        include_docs: true,
        startkey: "54messages4stream",
        endkey: "54messages4stream5",
      }).then((allDocs) => {
        console.log("!live deleting ", allDocs);
        allDocs.rows.map((row) => {
          try {
            row.doc._deleted = true;
            db.put(row.doc);
          } catch (err) {}
        });
      });
      return { ...state };
    case "CACHE_COUNT":
      return {
        ...state,
        liveCount: action.values.liveCount,
      };
    case "UPSERT_REC_IDS":
      db = action.values.db;
      action.values.docs.map((doc) => {
        db.upsert(doc._id, (existingDoc) =>
          compareDocs(existingDoc, doc) ? false : doc
        )
          .then(() => {
            // success
          })
          .catch((err) => {
            if (err.name === "conflict") {
              // conflict!
            } else {
              // other error
            }
          });
      });

      return {
        ...state,
      };
    case "UPSERT_REC_ID":
      console.log("UPSERT_REC_ID ", action.values.doc);
      db = action.values.db;
      db.upsert(action.values.doc._id, (existingDoc) =>
        compareDocs(existingDoc, action.values.doc) ? false : action.values.doc
      )
        .then(() => {
          // success
        })
        .catch((err) => {
          if (err.name === "conflict") {
            // conflict!
          } else {
            // other error
          }
        });
      return {
        ...state,
      };
    case "UPSERT_REC":
      console.log("NOTIFY UPSERT_REC", Date.now(), action);
      db = action.values.db;
      doc = prepDoc(
        action.values.collection,
        action.values.table,
        action.values.rowid,
        action.values.doc
      );
      console.log("UPSERT_REC ", doc);
      db.upsert(doc._id, (existingDoc) =>
        compareDocs(existingDoc, doc) ? false : doc
      )
        .then(() => {
          // success
          if (pluckTypes.indexOf(doc.type) > -1) {
            console.log("NOTIFY UPSERT", Date.now(), action);
            action.values.notify && pluck.play();
          }
        })
        .catch((err) => {
          if (err.name === "conflict") {
            // conflict!
          } else {
            // other error
          }
        });
      return {
        ...state,
      };
    case "ADD_RECORD":
      db = action.values.db;
      doc = prepDoc(
        action.values.collection,
        action.values.table,
        action.values.rowid,
        action.values.doc
      );
      db.put(doc)
        .then(() => {
          // success
        })
        .catch((err) => {
          if (err.name === "conflict") {
            // conflict!
          } else {
            // some other error
          }
        });
      return {
        ...state,
      };
    case "ADD_RECORD_ID":
      db = action.values.db;
      db.put(action.values.doc)
        .then(() => {
          // success
        })
        .catch((err) => {
          if (err.name === "conflict") {
            // conflict!
          } else {
            // some other error
          }
        });
      return {
        ...state,
      };
    case "RETAIN_HISTORY":
      db = action.values.db;
      db &&
        db
          .allDocs({
            include_docs: true,
            startkey: "54messages4" + action.values.topic,
            endkey: "54messages4" + action.values.topic + "5",
          })
          .then((allDocs) => {
            let latest = allDocs.rows
              .map((row) => row.doc.msg_idx)
              .sort()
              .slice(-action.values.num);
            allDocs.rows.map((row) => {
              try {
                if (!latest.includes(row.doc.msg_idx)) {
                  row.doc._deleted = true;
                  return db.put(row.doc);
                }
              } catch (err) {}
            });
          });
      return {
        ...state,
      };

    case "MARK_READ":
      db = action.values.db;
      let id = prepDoc(
        action.values.collection,
        action.values.table,
        action.values.rowid,
        {}
      )._id;
      db.get(id)
        .then((d) => {
          if (!d.read) {
            d.read = true;
            db.put(d);
          }
          return null;
        })
        .catch(function (err) {
          // error
        });
      return {
        ...state,
      };

    case "DELETE_RECORD":
      db = action.values.db;
      doc = prepDoc(
        action.values.collection,
        action.values.table,
        action.values.rowid,
        action.values.doc
      );
      db.get(doc._id)
        .then((d) => {
          d._deleted = true;
          return db.put(d);
        })
        .then(function (result) {
          // handle result
        })
        .catch(function (err) {
          // error
        });
      return {
        ...state,
      };

    case "DELETE_RECORD_ID":
      db = action.values.db;
      console.log("DELETE_RECORD_ID action", action);
      db.get(action.values.doc._id)
        .then((d) => {
          console.log("DELETE_RECORD_ID ", d);
          if (d._deleted) {
            return null;
          } else {
            d._deleted = true;
            return db.put(d);
          }
        })
        .then((result) => {
          console.log("DELETE_RECORD_ID result", result);
        })
        .catch((err) => {
          // console.log("DELETE_RECORD_ID error", err);
        });
      return {
        ...state,
      };
    case "DELETE_SMID":
      db = action.values.db;
      db.allDocs({
        include_docs: true,
        startkey: action.values.startkey,
        endkey: action.values.endkey,
      }).then((allDocs) => {
        allDocs.rows.map((row) => {
          try {
            if (
              action.values.jMessage.smid === row.doc.smid &&
              action.values.jMessage.msg_idx !== row.doc.msg_idx
            ) {
              row.doc._deleted = true;
              return db.put(row.doc._deleted);
            }
          } catch (err) {}
        });
      });
      return {
        ...state,
      };
    case "CREATE_USER_DB":
      db = new PouchDB(action.values.dbUrl, { size: 1, revs_limit: 1 });
      return {
        ...state,
        dbUser: db,
      };
    case "CREATE_MASTER_DB":
      db = new PouchDB(action.values.dbUrl, { size: 50, revs_limit: 1 });
      db.crypto(action.values.pwd, {
        iterations: 10000,
        cb: action.values.cb,
      });
      return {
        ...state,
        dbMaster: db,
        dbReady: false,
      };
    case "MASTER_DB_READY":
      return {
        ...state,
        dbReady: action.values.ready,
      };
    case "ADD_LISTENER":
      // state.dbMaster.setMaxListeners(20);
      state.dbMaster
        .changes(action.values.options)
        .on("change", action.values.onChange)
        .on("error", action.values.onError);
      return {
        ...state,
      };
    case "ADD_DB":
      // Create the database
      // If successful:
      // Add the entry to the parent database (dbMaster)
      let dbArray = state.dbList;
      dbArray.indexOf(action.values.dbString) === -1
        ? dbArray.push(action.values.dbString)
        : console.log("item already exists");
      return {
        ...state,
      };
    case "SET_DB":
      return {
        ...state,
        dbMaster: action.values.database,
      };
    default: {
      return state;
    }
  }
};

const useDatabaseState = (state) => {
  const [databaseState, databaseDispatch] = useReducer(reducer, state);
  return { databaseState, databaseDispatch };
};

export default useDatabaseState;
